// @flow
import React, { Component } from 'react'
import type { Node } from 'react'

type Props = {|
  children: Node,
  className?: string,
  onClick: Function
|}

export default class AjaxLink extends Component<Props> {
  render() {
    const { children, className, onClick } = this.props
    return (
      <a
        href="#"
        className={className}
        onClick={(e) => {
          e.preventDefault()
          onClick()
        }}
      >
        {children}
      </a>
    )
  }
}
